import styled, { css } from 'styled-components';
import { HubRichTextBackground } from '@/__generated__/graphql';
import { BorderRadius, colors, GridContainerEdge, GridWrapper, mediaQueries } from '@theme/lib';
import { getBicentenaryRichTextStyling } from '../RichText';
import { isBicentenary } from '@/lib/utils';

interface AudioGridContainerProps {
  field_remove_spacing?: boolean;
}

export const AudioGridContainer = styled(GridContainerEdge)<AudioGridContainerProps>`
  padding-top: 2rem;
  padding-bottom: 2rem;
  ${mediaQueries.md} {
    padding-top: 3.125rem;
    padding-bottom: 3.125rem;
  }
  ${(props) => props.field_remove_spacing === true ? css`
    margin: 0 !important;
  ` : ``};
`;

export const AudioGridWrapper = styled(GridWrapper)`
  display: flex;
  flex-flow: column;

  .accordion-item {
    margin-top: 10px;
  }

  .accordion-label,
  .accordion-item--closed .accordion-label,
  .accordion-item--opened .accordion-label {
    text-decoration: none;
    color: ${colors.white};
    &:after {
      background-color: ${colors.honeyBee};
    }
    &:hover {
      color: ${colors.honeyBee};
      text-decoration: none;
    }
  }

  .accordion-item--opened .accordion-label {
    color: ${colors.seagrass};
    &:after {
      background-color: ${colors.seagrass};
    }
    &:hover {
      color: ${colors.seagrass};
    }
  }

  .accordion-label {
    color: ${colors.white};
    &:hover {
      color: ${colors.white};
    }
  }
`;

export const StyledImage = styled('div')`
  grid-column: 1 / span 5;
  img {
    ${(props) => BorderRadius(props.theme.config.imageBorderRadius.mobile)};
    overflow: hidden;
    width: 100%;

    ${mediaQueries.md} {
      ${(props) => BorderRadius(props.theme.config.imageBorderRadius.desktop)};
    }
  }
  margin-bottom: 1.875rem;
  justify-self: center;
  ${mediaQueries.md} {
    margin-bottom: 1.5rem;
    align-self: center;
    grid-column: 1 / span 4;
  }
`;

export const AudioWaveSurferContainer = styled('div')`
  margin-bottom: 0.875rem;
  ${mediaQueries.md} {
    margin-bottom: 0.5rem;
  }
  div::part(scroll) {
    border-radius: ${(props) => props.theme.config.componentRadius};
    background-color: #2D2D2D;
    margin-bottom: 1.875rem;
    ${mediaQueries.md} {
      margin-bottom: 1.5rem;
    }
  }
`;
